import type { GanttFornecedorObrasProps } from "./types-gantt-fornecedor-obras";
import { useGanttFornecedorObras } from "./use-gantt-fornecedor-obras";
import { GanttFornecedorObrasView } from "./view-gantt-fornecedor-obras";

export function GanttFornecedorObras(props: GanttFornecedorObrasProps) {
  const vm = useGanttFornecedorObras(props);

  return <GanttFornecedorObrasView {...vm} />;
}

export type * from "./types-gantt-fornecedor-obras";
